import { Component, OnInit } from '@angular/core';

import { AuthenticationService } from "../../../services/login/authentication.service";
import { UserService } from "../../../services/shared/user.service";
import { DomSanitizer } from "@angular/platform-browser";

@Component({
  selector: 'app-userblock',
  templateUrl: './userblock.component.html',
  styleUrls: ['./userblock.component.scss']
})
export class UserblockComponent implements OnInit {

  public user: any;
  public profilePicture: any;

  constructor(private userService: UserService,
    private authenticationService: AuthenticationService,
    private domSanitizer: DomSanitizer) {

  }

  public ngOnInit() {
    this.userService.get.subscribe((result) => {
      this.user = result;
      this.profilePicture =
        this.domSanitizer.bypassSecurityTrustResourceUrl('data:image/jpg;base64,' +
          this.user.profilePictureBase64);
    }, (error) => console.log(error));
  }

  public userBlockIsVisible() {
    return this.user != null && this.userService.getVisibility();
  }

  public logout() { this.authenticationService.logout(); }

}
